<template>
  <header class="titlebar">
    <span v-for="(v, k) in breadcrumb">
      <span v-if="k && !v.badge" class="px-1">/</span>

      <span v-if="!v.badge">{{ v }}</span>
      <span v-else class="pl-1"
        ><b-badge>{{ v.badge }}</b-badge></span
      >
    </span>

    <span v-if="loading" class="pl-1">
      <i class="fa fa-circle-o-notch fa-spin fa-fw"></i>
    </span>
    <div class="ml-auto mr-auto"><!-- auto-growing spacer --></div>
    <div>
        <template>
            <portal-target name="registration-report"></portal-target>
        </template>
        <template>
            <portal-target name="nda-search"></portal-target>
        </template>
    </div>
  </header>
</template>

<script>
import {mapState} from 'vuex'

export default {
  computed: {
    ...mapState(['breadcrumb', 'loading']),
  },
}
</script>
